export default __webpack_public_path__ + "static/hero-11-fa3038a3f60a893cda5e6ce1b6d2a6b5.webp";